import { render } from "./MimamoriHistoryComponent.vue?vue&type=template&id=7b8d8534&scoped=true"
import script from "./MimamoriHistoryComponent.vue?vue&type=script&lang=js"
export * from "./MimamoriHistoryComponent.vue?vue&type=script&lang=js"

import "./MimamoriHistoryComponent.vue?vue&type=style&index=0&id=7b8d8534&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b8d8534"]])

export default __exports__